module.exports = __webpack_public_path__ + "static/media/slider_deactive.c32649d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider_deactive.svg
// module id = 37
// module chunks = 0